/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { useFrame } from "@react-three/fiber";

type GLTFResult = GLTF & {
  nodes: {
    Plane004: THREE.Mesh;
    ground: THREE.Mesh;
    brigde: THREE.Mesh;
    Plane001: THREE.Mesh;
    Plane002_1: THREE.Mesh;
    Plane003_1: THREE.Mesh;
    Tree: THREE.Mesh;
    Cube_1: THREE.Mesh;
    Cube001: THREE.Mesh;
    Cube002: THREE.Mesh;
    Cube003: THREE.Mesh;
    Cube004: THREE.Mesh;
    Cube005: THREE.Mesh;
    Cube006: THREE.Mesh;
    Cube007: THREE.Mesh;
    Cube008: THREE.Mesh;
    Cube018: THREE.Mesh;
    Tree001: THREE.Mesh;
    Cube009: THREE.Mesh;
    Cube010: THREE.Mesh;
    Cube011: THREE.Mesh;
    Cube012: THREE.Mesh;
    Cube013: THREE.Mesh;
    Cube014: THREE.Mesh;
    Cube015: THREE.Mesh;
    Cube016: THREE.Mesh;
    Cube017: THREE.Mesh;
    Bursh: THREE.Mesh;
    bench: THREE.Mesh;
    Vert001_1: THREE.Mesh;
    Vert006: THREE.Mesh;
    Circle: THREE.Mesh;
    Circle_1: THREE.Mesh;
    Circle001: THREE.Mesh;
    Circle001_1: THREE.Mesh;
    path: THREE.Mesh;
    Plane: THREE.Mesh;
    grass001: THREE.Mesh;
    grass004: THREE.Mesh;
    rock: THREE.Mesh;
    rock001: THREE.Mesh;
    rock002: THREE.Mesh;
    rock003: THREE.Mesh;
    rock004: THREE.Mesh;
    rock005: THREE.Mesh;
    rock006: THREE.Mesh;
    grass005: THREE.Mesh;
    grass006: THREE.Mesh;
    grass007: THREE.Mesh;
    grass008: THREE.Mesh;
    grass009: THREE.Mesh;
    grass010: THREE.Mesh;
    grass011: THREE.Mesh;
    grass012: THREE.Mesh;
    grass: THREE.Mesh;
    tile: THREE.Mesh;
    tile001: THREE.Mesh;
    tile002: THREE.Mesh;
    tile003: THREE.Mesh;
    tile004: THREE.Mesh;
    tile005: THREE.Mesh;
    tile006: THREE.Mesh;
    tile007: THREE.Mesh;
    tile008: THREE.Mesh;
    tile009: THREE.Mesh;
    tile010: THREE.Mesh;
    tile011: THREE.Mesh;
    tile012: THREE.Mesh;
    tile013: THREE.Mesh;
    tile014: THREE.Mesh;
    tile015: THREE.Mesh;
    tile016: THREE.Mesh;
    tile017: THREE.Mesh;
    tile018: THREE.Mesh;
    tile019: THREE.Mesh;
    tile020: THREE.Mesh;
    tile021: THREE.Mesh;
    tile022: THREE.Mesh;
    tile023: THREE.Mesh;
    tile024: THREE.Mesh;
    tile027: THREE.Mesh;
  };
  materials: {
    background: THREE.MeshStandardMaterial;
    ground: THREE.MeshStandardMaterial;
    ["rock 2"]: THREE.MeshStandardMaterial;
    rock: THREE.MeshStandardMaterial;
    wood: THREE.MeshStandardMaterial;
    ["wood 2"]: THREE.MeshStandardMaterial;
    tree: THREE.MeshStandardMaterial;
    metal: THREE.MeshStandardMaterial;
    ["Material.001"]: THREE.MeshStandardMaterial;
    water: THREE.MeshStandardMaterial;
    grass: THREE.MeshStandardMaterial;
  };
};

export default function Model({ ...props }: JSX.IntrinsicElements["group"]) {
  const group = useRef<THREE.Group>(null);
  const { nodes, materials } = useGLTF("chapter1.1.glb") as GLTFResult;

  useFrame(({ clock }) => {
    if (group.current) {
      const a = clock.getElapsedTime();
      group.current.rotation.y = a * 0.2;
    }
  });

  return (
    <group ref={group} {...props} dispose={null}>
      {/* <mesh
        geometry={nodes.Plane004.geometry}
        material={materials.background}
        scale={14.28}
      /> */}
      <mesh
        geometry={nodes.ground.geometry}
        material={materials.ground}
        scale={4}
        receiveShadow
      />
      <mesh
        castShadow
        geometry={nodes.brigde.geometry}
        material={materials["rock 2"]}
        position={[-0.16, 1, -0.05]}
        scale={[1, 1, 1.72]}
      >
        <mesh
          receiveShadow
          geometry={nodes.Plane001.geometry}
          material={materials.rock}
        />
        <mesh
          receiveShadow
          geometry={nodes.Plane002_1.geometry}
          material={materials.wood}
        />
        <mesh
          receiveShadow
          geometry={nodes.Plane003_1.geometry}
          material={materials["wood 2"]}
          position={[0, 0.68, 0]}
        />
      </mesh>
      <mesh
        castShadow
        geometry={nodes.Tree.geometry}
        material={materials.wood}
        position={[-2.52, 1.2, 3.11]}
        rotation={[0, -0.37, 0]}
        scale={1.34}
      >
        <mesh
          geometry={nodes.Cube_1.geometry}
          material={materials.tree}
          position={[-0.51, 2.22, 0.62]}
          rotation={[0.24, 0.15, -0.01]}
          scale={1.26}
        />
        <mesh
          geometry={nodes.Cube001.geometry}
          material={materials.tree}
          position={[-0.16, 2.26, -0.37]}
          rotation={[-0.23, 0.09, 0.1]}
          scale={1.14}
        />
        <mesh
          geometry={nodes.Cube002.geometry}
          material={materials.tree}
          position={[0.86, 2.01, 0.09]}
          rotation={[-0.25, -0.28, -0.09]}
          scale={1.05}
        />
        <mesh
          geometry={nodes.Cube003.geometry}
          material={materials.tree}
          position={[1.25, 1.2, 0.08]}
          rotation={[-0.07, -0.05, -0.21]}
          scale={1.21}
        />
        <mesh
          geometry={nodes.Cube004.geometry}
          material={materials.tree}
          position={[0.55, 1.32, -0.56]}
          rotation={[-0.1, -0.14, 0.18]}
          scale={1.11}
        />
        <mesh
          geometry={nodes.Cube005.geometry}
          material={materials.tree}
          position={[-0.2, 1.6, -0.99]}
          rotation={[-0.07, -0.05, -0.21]}
          scale={1.21}
        />
        <mesh
          geometry={nodes.Cube006.geometry}
          material={materials.tree}
          position={[-0.39, 1.01, 0.62]}
          rotation={[-0.01, 0.04, 0.44]}
          scale={1.08}
        />
        <mesh
          geometry={nodes.Cube007.geometry}
          material={materials.tree}
          position={[0.43, 1.42, 0.67]}
          rotation={[0.21, -0.1, -0.05]}
          scale={1.11}
        />
        <mesh
          geometry={nodes.Cube008.geometry}
          material={materials.tree}
          position={[-0.69, 1.42, -0.22]}
          rotation={[0.21, -0.1, -0.05]}
          scale={1.11}
        />
        <mesh
          geometry={nodes.Cube018.geometry}
          material={materials.tree}
          position={[0.15, 2.64, 0.25]}
          rotation={[-0.25, -0.28, -0.09]}
          scale={1.05}
        />
      </mesh>
      <mesh
        castShadow
        geometry={nodes.Tree001.geometry}
        material={materials.wood}
        position={[-2.86, 1.2, -2.21]}
        rotation={[-Math.PI, 1.15, -Math.PI]}
      >
        <mesh
          geometry={nodes.Cube009.geometry}
          material={materials.tree}
          position={[-0.37, 2.13, 0.49]}
          scale={1.26}
        />
        <mesh
          geometry={nodes.Cube010.geometry}
          material={materials.tree}
          position={[-0.16, 2.26, -0.37]}
          rotation={[-0.23, 0.09, 0.1]}
          scale={1.14}
        />
        <mesh
          geometry={nodes.Cube011.geometry}
          material={materials.tree}
          position={[0.69, 2.05, 0.11]}
          rotation={[-0.11, -0.21, 0.22]}
          scale={1.05}
        />
        <mesh
          geometry={nodes.Cube012.geometry}
          material={materials.tree}
          position={[1.25, 1.2, 0.08]}
          rotation={[-0.07, -0.05, -0.21]}
          scale={1.21}
        />
        <mesh
          geometry={nodes.Cube013.geometry}
          material={materials.tree}
          position={[0.55, 1.32, -0.56]}
          rotation={[-0.1, -0.14, 0.18]}
          scale={1.11}
        />
        <mesh
          geometry={nodes.Cube014.geometry}
          material={materials.tree}
          position={[-0.2, 1.6, -0.99]}
          rotation={[-0.07, -0.05, -0.21]}
          scale={1.21}
        />
        <mesh
          geometry={nodes.Cube015.geometry}
          material={materials.tree}
          position={[-0.39, 1.01, 0.62]}
          rotation={[-0.01, 0.04, 0.44]}
          scale={1.08}
        />
        <mesh
          geometry={nodes.Cube016.geometry}
          material={materials.tree}
          position={[0.43, 1.42, 0.67]}
          rotation={[0.21, -0.1, -0.05]}
          scale={1.11}
        />
        <mesh
          geometry={nodes.Cube017.geometry}
          material={materials.tree}
          position={[-0.69, 1.42, -0.22]}
          rotation={[0.21, -0.1, -0.05]}
          scale={1.11}
        />
      </mesh>
      <mesh
        castShadow
        geometry={nodes.Bursh.geometry}
        material={materials.tree}
        position={[3.14, 1.4, -3.02]}
        rotation={[0, Math.PI / 2, 0]}
        scale={1.32}
      />
      <mesh
        castShadow
        geometry={nodes.bench.geometry}
        material={materials.wood}
        position={[2.91, 1.6, 2.32]}
        scale={[0.73, 0.73, 0.28]}
      >
        <mesh
          castShadow
          geometry={nodes.Vert001_1.geometry}
          material={materials.metal}
          position={[0, -0.54, -0.69]}
          scale={[1, 1, 2.63]}
        />
        <mesh
          castShadow
          geometry={nodes.Vert006.geometry}
          material={materials.metal}
          position={[0, -0.54, -0.23]}
          scale={[1, 1, 2.63]}
        />
      </mesh>
      <group castShadow position={[2.73, 1.2, 1.17]} scale={0.39}>
        <mesh
          castShadow
          geometry={nodes.Circle.geometry}
          material={materials.metal}
        />
        <mesh
          geometry={nodes.Circle_1.geometry}
          material={materials["Material.001"]}
        />
      </group>
      <group castShadow position={[-2.21, 1.2, -3.56]} scale={0.39}>
        <mesh
          castShadow
          geometry={nodes.Circle001.geometry}
          material={materials.metal}
        />
        <mesh
          geometry={nodes.Circle001_1.geometry}
          material={materials["Material.001"]}
        />
      </group>
      <mesh
        castShadow
        geometry={nodes.path.geometry}
        material={materials.rock}
        position={[0, 1.01, 0]}
        scale={[1, 1, 4]}
      />
      <mesh
        receiveShadow
        geometry={nodes.Plane.geometry}
        material={materials.water}
        position={[0, 0.62, 0]}
        scale={[3.87, 1.34, 1.4]}
      />
      <mesh
        receiveShadow
        geometry={nodes.grass001.geometry}
        material={materials.grass}
        scale={4}
      />
      <mesh
        receiveShadow
        geometry={nodes.grass004.geometry}
        material={materials.grass}
        position={[2.94, 1, -2.92]}
      />
      <mesh
        castShadow
        geometry={nodes.rock.geometry}
        material={materials.rock}
        position={[-1.99, 1.2, 2.17]}
        scale={1.44}
      />
      <mesh
        castShadow
        geometry={nodes.rock001.geometry}
        material={materials.rock}
        position={[-0.76, 1.2, 2.98]}
        rotation={[0, Math.PI / 2, 0]}
        scale={1.02}
      />
      <mesh
        castShadow
        geometry={nodes.rock002.geometry}
        material={materials.rock}
        position={[1.68, 1.2, -2.03]}
        rotation={[0, Math.PI / 2, 0]}
        scale={1.32}
      />
      <mesh
        castShadow
        geometry={nodes.rock003.geometry}
        material={materials.rock}
        position={[0.4, 0.91, -0.71]}
        rotation={[0, -0.93, 0]}
        scale={1.32}
      />
      <mesh
        castShadow
        geometry={nodes.rock004.geometry}
        material={materials.rock}
        position={[1.29, 0.69, 0.75]}
        rotation={[0, -0.93, 0]}
        scale={1.32}
      />
      <mesh
        castShadow
        geometry={nodes.rock005.geometry}
        material={materials.rock}
        position={[2.26, 0.71, -1.02]}
        rotation={[0, -0.93, 0]}
        scale={1.32}
      />
      <mesh
        castShadow
        geometry={nodes.rock006.geometry}
        material={materials.rock}
        position={[-2.52, 0.69, 0.38]}
        rotation={[0, -0.3, 0]}
        scale={1.32}
      />
      <mesh
        castShadow
        geometry={nodes.grass005.geometry}
        material={materials.tree}
        position={[3.8, 1.2, 3.81]}
      />
      <mesh
        castShadow
        geometry={nodes.grass006.geometry}
        material={materials.tree}
        position={[3.72, 1.2, 0.88]}
        rotation={[0, 0.77, 0]}
        scale={0.89}
      />
      <mesh
        castShadow
        geometry={nodes.grass007.geometry}
        material={materials.tree}
        position={[1.85, 1.2, 2.69]}
        rotation={[0, 0.77, 0]}
        scale={0.89}
      />
      <mesh
        castShadow
        geometry={nodes.grass008.geometry}
        material={materials.tree}
        position={[-1.93, 1.2, 3.19]}
        rotation={[0, 0.77, 0]}
        scale={0.89}
      />
      <mesh
        castShadow
        geometry={nodes.grass009.geometry}
        material={materials.tree}
        position={[-2.22, 1.2, 3.6]}
        rotation={[0, 0.77, 0]}
        scale={0.89}
      />
      <mesh
        castShadow
        geometry={nodes.grass010.geometry}
        material={materials.tree}
        position={[-3.65, 1.2, 3.45]}
        rotation={[0, 0.77, 0]}
        scale={1.3}
      />
      <mesh
        castShadow
        geometry={nodes.grass011.geometry}
        material={materials.tree}
        position={[-2.85, 1.2, -3.42]}
        rotation={[0, 0.77, 0]}
        scale={1.04}
      />
      <mesh
        castShadow
        geometry={nodes.grass012.geometry}
        material={materials.tree}
        position={[2.72, 1.2, -1.54]}
        rotation={[0, 0.77, 0]}
        scale={0.89}
      />
      <mesh
        castShadow
        geometry={nodes.grass.geometry}
        material={materials.tree}
        position={[1.15, 1.2, -3.3]}
        rotation={[0, 0.77, 0]}
        scale={1.22}
      />
      <mesh
        castShadow
        geometry={nodes.tile.geometry}
        material={materials.rock}
        position={[-0.02, 0.9, 2.12]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile001.geometry}
        material={materials.rock}
        position={[0.48, 0.9, 2.22]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile002.geometry}
        material={materials.rock}
        position={[0.84, 0.9, 2.44]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile003.geometry}
        material={materials.rock}
        position={[0.42, 0.9, 2.87]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile004.geometry}
        material={materials.rock}
        position={[0.8, 0.9, 2.98]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile005.geometry}
        material={materials.rock}
        position={[0.5, 0.9, 3.46]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile006.geometry}
        material={materials.rock}
        position={[1.13, 0.9, 2.77]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile007.geometry}
        material={materials.rock}
        position={[1.22, 0.9, 3.25]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile008.geometry}
        material={materials.rock}
        position={[1.24, 0.9, 3.6]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile009.geometry}
        material={materials.rock}
        position={[-1.14, 0.9, -3.42]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile010.geometry}
        material={materials.rock}
        position={[-0.79, 0.9, -3.2]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile011.geometry}
        material={materials.rock}
        position={[-1.03, 0.9, -2.87]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile012.geometry}
        material={materials.rock}
        position={[-0.65, 0.9, -2.75]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile013.geometry}
        material={materials.rock}
        position={[-0.97, 0.9, -2.44]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile014.geometry}
        material={materials.rock}
        position={[-0.33, 0.9, -3.13]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile015.geometry}
        material={materials.rock}
        position={[0.11, 0.9, -2.07]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile016.geometry}
        material={materials.rock}
        position={[-0.47, 0.9, -2.14]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile017.geometry}
        material={materials.rock}
        position={[-0.18, 0.9, -3.75]}
        scale={0.15}
      />
      <mesh
        castShadow
        geometry={nodes.tile018.geometry}
        material={materials.rock}
        position={[-0.64, 1.79, 0.15]}
        scale={[0.15, 0.04, 0.14]}
      />
      <mesh
        castShadow
        geometry={nodes.tile019.geometry}
        material={materials.rock}
        position={[-0.22, 1.68, 0.34]}
        rotation={[0.17, 0, 0]}
        scale={[0.15, 0.07, 0.15]}
      />
      <mesh
        castShadow
        geometry={nodes.tile020.geometry}
        material={materials.rock}
        position={[-0.53, 1.63, 0.67]}
        rotation={[0.17, 0, 0]}
        scale={[0.15, 0.07, 0.15]}
      />
      <mesh
        castShadow
        geometry={nodes.tile021.geometry}
        material={materials.rock}
        position={[-0.15, 1.59, 0.78]}
        rotation={[0.39, 0, 0]}
        scale={[0.15, 0.06, 0.15]}
      />
      <mesh
        castShadow
        geometry={nodes.tile022.geometry}
        material={materials.rock}
        position={[-0.47, 1.46, 1.1]}
        rotation={[0.39, 0, 0]}
        scale={[0.15, 0.06, 0.15]}
      />
      <mesh
        castShadow
        geometry={nodes.tile023.geometry}
        material={materials.rock}
        position={[-0.05, 1.71, -0.47]}
        rotation={[-0.17, 0, 0]}
        scale={[0.15, 0.07, 0.15]}
      />
      <mesh
        castShadow
        geometry={nodes.tile024.geometry}
        material={materials.rock}
        position={[0.09, 1.74, -0.04]}
        scale={[0.15, 0.06, 0.15]}
      />
      <mesh
        castShadow
        geometry={nodes.tile027.geometry}
        material={materials.rock}
        position={[-0.57, 1.55, -1.04]}
        rotation={[-0.39, 0, 0]}
        scale={[0.15, 0.06, 0.15]}
      />
    </group>
  );
}

useGLTF.preload("chapter1.1.glb");
